import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchHospitalJobs } from "../../store/hospitalSlice";

const JobList = () => {
  const dispatch = useDispatch();
  const { jobs, status } = useSelector((state) => state.hospital);

  useEffect(() => {
    dispatch(fetchHospitalJobs());
  }, [dispatch]);

  return (
    <div className="col-lg-12">
      <div className="table-wrapper2">
        <div className="title-and-btn">
          <div className="title">
            <h4>Hospital Job List</h4>
          </div>
          <div className="job-post-btn">
            <Link className="primry-btn-2" to="/post-job">
              Create Job Post
            </Link>
          </div>
        </div>

        {status === "loading" ? (
          <p>Loading jobs...</p>
        ) : (
          <table className="eg-table table job-list-table mb-0">
            <thead>
              <tr>
                <th>Job Title</th>
                <th>Department</th>
                <th>Type</th>
                <th>Location</th>
                <th>Status</th>
                <th>Deadline</th>
              </tr>
            </thead>
            <tbody>
              {jobs.length === 0 ? (
                <tr>
                  <td colSpan="6">No jobs posted yet.</td>
                </tr>
              ) : (
                jobs.map((job) => (
                  <tr key={job._id}>
                    <td>{job.title}</td>
                    <td>{job.department || "-"}</td>
                    <td>{job.employmentType || "-"}</td>
                    <td>{job.location || "-"}</td>
                    <td>{job.status}</td>
                    <td>{job.deadline ? new Date(job.deadline).toLocaleDateString() : "-"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default JobList;

